// extracted by mini-css-extract-plugin
module.exports = {"headButtons":"headButtons_headButtons__1_mMn","back":"headButtons_back__Rwr3Y","logo":"headButtons_logo__MGC3Y","toggleFulLScreen":"headButtons_toggleFulLScreen__2klQn"};